import React, { useState, useRef, useEffect } from "react";
import * as Mui from "@mui/material";
import { scrollTop } from "services/constants";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import {
  designColors,
  designShell,
  paginationFooter,
  rowsPerPageOptions,
} from "services/constants/designTokens";

const cellSx = {
  py: 1,
  fontSize: 13,
  color: designColors.slate800,
  borderBottom: `1px solid ${designColors.slate100}`,
  whiteSpace: "nowrap",
};

export const LeaveHistory = ({ leaveCreditDebitDetails, masterData }) => {
  const [leavePage, setLeavePage] = useState(0);
  const [leaverowsPerPage, setLeaveRowsPerPage] = useState(rowsPerPageOptions[0]);
  const containerRef = useRef(null);

  const handleChangeLeaveRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [leavePage]);

  return (
    <React.Fragment>
      <Mui.TableContainer ref={containerRef} sx={{ overflowX: "auto" }}>
        <Mui.Table size="small" sx={{ minWidth: 640 }}>
          <Mui.TableHead>
            <Mui.TableRow>
              {["Date", "Leave Type", "Description", "Credit", "Debit", "By"].map((label) => (
                <Mui.TableCell
                  key={label}
                  sx={{ ...designShell.tableHeadCellBase, py: 1, whiteSpace: "nowrap" }}
                >
                  {label}
                </Mui.TableCell>
              ))}
            </Mui.TableRow>
          </Mui.TableHead>
          <Mui.TableBody>
            {leaveCreditDebitDetails?.length === 0 ? (
              <TableEmptyState dataLength={masterData} />
            ) : (
              leaveCreditDebitDetails
                ?.slice(
                  leavePage * leaverowsPerPage,
                  leavePage * leaverowsPerPage + leaverowsPerPage,
                )
                .map((leave, index) => (
                  <Mui.TableRow key={leave.id ?? index} sx={designShell.tableRowHover}>
                    <Mui.TableCell sx={cellSx}>{leave.date}</Mui.TableCell>
                    <Mui.TableCell sx={cellSx}>{leave.leave_type_name}</Mui.TableCell>
                    <Mui.TableCell
                      sx={{ ...cellSx, maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      <Mui.Tooltip title={leave.description || ""}>
                        <span>{leave.description}</span>
                      </Mui.Tooltip>
                    </Mui.TableCell>
                    <Mui.TableCell sx={{ ...cellSx, color: "#16A34A", fontWeight: 600 }}>
                      {leave?.credit || leave?.credit === 0 ? leave?.credit : 0}
                    </Mui.TableCell>
                    <Mui.TableCell sx={{ ...cellSx, color: "#DC2626", fontWeight: 600 }}>
                      {leave?.debit || leave?.debit === 0 ? leave?.debit : 0}
                    </Mui.TableCell>
                    <Mui.TableCell sx={cellSx}>{leave.createdby || "N/A"}</Mui.TableCell>
                  </Mui.TableRow>
                ))
            )}
          </Mui.TableBody>
        </Mui.Table>
        {leaveCreditDebitDetails?.length > leaverowsPerPage ? (
          <Mui.Box
            sx={{
              minWidth: 640,
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              backgroundColor: designColors.white,
              borderTop: `1px solid ${designColors.slate200}`,
              pt: 1.5,
              pb: 0.5,
            }}
          >
            {paginationFooter({
              page: leavePage,
              rowsPerPage: leaverowsPerPage,
              total: leaveCreditDebitDetails.length,
              itemLabel: "entries",
              onPageChange: setLeavePage,
              onRowsPerPageChange: handleChangeLeaveRowsPerPage,
              rowsPerPageOptions,
              compact: true,
            })}
          </Mui.Box>
        ) : null}
      </Mui.TableContainer>
    </React.Fragment>
  );
};
